import { useEditor } from '@craftjs/core'
import { ListItem } from 'twyne-new.ui'

export default function DraggableAssetItem({ item }) {
  const { element, icon, text } = item
  const { connectors: { create } } = useEditor()

  return <div ref={ref => create(ref, element)}>
    <ListItem
      value={<div className='flex items-center gap-2'>
        {icon}
        {text}
      </div>}
    />
  </div>
}
